<div class="container" [hidden]="!appService.markers.length">
  <div [hidden]="!loading">
    Enviando...
  </div>
  <div [hidden]="!submitted">
    <p>Gracias por participar</p>
    {{diagnostic}}
  </div>
  <div [hidden]="submitted">
  <h1 i18n="Add content">Agrega un nuevo sonido</h1>
  <p i18n="New content">Publica nuevos contenidos</p>
  <h2>Coord: {{appService.markers}}</h2>
  {{diagnostic}}
  <form (ngSubmit)="onSubmit()" #documentForm="ngForm">
    <div class="form-group">
        <label for="title">Título</label>
        <input type="text" id="title" [(ngModel)]="document.title" name="title" required/>
    </div>
    <div class="form-group">
        <label for="author">Autor/a</label>
        <input type="text" id="author" [(ngModel)]="document.author" name="author" required/>
    </div>
    <div class="form-group">
        <label for="description">Descripción</label>
        <textarea id="description" [(ngModel)]="document.description" name="description"></textarea>
    </div>
    <div class="form-group">
        <label for="category">Categoría</label>
        <select id="category" [(ngModel)]="document.category" name="category" required>
          <option *ngFor="let cat of categories" [value]="cat">{{cat}}</option>
        </select>
    </div>
    <div class="form-group">
      <label for="file">Fichero</label>
      <input type="file" id="file" name="file" (change)="onFileChange($event)" required/>
    </div>
    <button type="submit" [disabled]="documentForm.form.invalid">Envía</button>
    <button type="button" (click)="appService.clearMarker()">Cancela</button>
  </form>
</div>
</div>



// WEBPACK FOOTER //
// ./src/app/add-content/add-content.component.html